import React from 'react';

const LandingTopBar = ({ onLogoClick, onPrimaryActionClick, primaryActionLabel }) => {
  return (
    <header className="sticky top-0 z-navigation bg-card border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 h-16 flex items-center justify-between">
        <button type="button" onClick={onLogoClick} className="flex items-center gap-2">
          <div className="w-10 h-10 bg-primary/20 rounded-md flex items-center justify-center">
            <img src="/icon.png" alt="꿈현.Labs" className="w-7 h-7 object-contain" loading="eager" decoding="async" />
          </div>
          <div className="text-lg font-heading font-semibold text-foreground">
            kkumhyeon.<span className="text-primary">labas</span>
          </div>
        </button>

        <button
          type="button"
          onClick={onPrimaryActionClick}
          className="px-4 py-2 rounded-md bg-primary text-primary-foreground shadow-gaming-sm hover:shadow-gaming-md transition-gaming"
        >
          {primaryActionLabel}
        </button>
      </div>
    </header>
  );
};

export default LandingTopBar;
